/**
 * Created by Rain Laansalu on 03.11.2017.
 */
// export const apiUrl = 'https://beviralocal.com/midsign';
export const apiUrl = '';



//////////////////
// WEBPACK FOOTER
// ./src/js/constants.js
// module id = 1
// module chunks = 0